export const getPreviewRef = (previewData: unknown) =>
	typeof previewData === 'object' ? (previewData as { ref?: string }).ref || '' : ''

export const isUuid = (str: string) =>
	/^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(str)
